// 企业中心 - menu
import Layout from '@/layout'
import {
  ROLES_ADMIN,
  ROLES_ADMIN_OR_OPS,
  ROLES_CUSTOMER,
  ROLES_LINE,
  ROLES_OPEN_USER,
  ROLES_SYSTEM_USER
} from '@/utils/permission'

export default [
  {
    path: '/',
    redirect: '/userManage',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'kehuguanli-copy',
      isshow: false,
      roles: ROLES_CUSTOMER
    },
    children: [
      {
        path: 'userManage',
        component: () => import('@/views/manage/userManage'),
        meta: {
          title: '客户信息',
          isshow: false,
          roles: ROLES_CUSTOMER
        }
      },
      {
        path: 'manageDetail',
        hidden: true,
        component: () => import('@/views/manage/manageDetail')
      },
      {
        path: 'manageRenewal',
        hidden: true,
        component: () => import('@/views/manage/addRenewal')
      }
    ]
  },

  {
    path: '/operation',
    component: Layout,
    meta: {
      title: '后台运营',
      icon: 'yunyingguanli',
      isshow: false,
      roles: ROLES_OPEN_USER
    },
    children: [
      {
        path: 'openUser',
        component: () => import('@/views/operation/openUser'),
        meta: {
          title: '注册开户',
          roles: ROLES_OPEN_USER
        }
      }
    ]
  },
  {
    path: '/system',
    name: 'systemList',
    component: Layout,
    meta: {
      title: '系统用户',
      icon: 'chengyuanyonghuguanli',
      isshow: false,
      roles: ROLES_SYSTEM_USER
    },
    children: [
      {
        path: 'systemList',
        component: () => import('@/views/system/index'),
        meta: {
          title: '系统用户',
          isshow: false,
          roles: ROLES_SYSTEM_USER
        }
      }
    ]
  },
  {
    path: '/payConfig',
    component: Layout,
    meta: {
      title: '支付配置',
      icon: 'chengyuanyonghuguanli',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'payConfigList',
        component: () => import('@/views/payConfig/index'),
        meta: {
          title: '支付配置',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/data',
    component: Layout,
    meta: {
      title: '数据字典',
      icon: 'shujuzidian',
      isshow: false,
      roles: ROLES_ADMIN_OR_OPS
    },
    children: [
      {
        path: 'dataList',
        component: () => import('@/views/data/index'),
        meta: {
          title: '数据字典',
          isshow: false,
          roles: ROLES_ADMIN_OR_OPS
        }
      },
      {
        path: 'dataDetail',
        component: () => import('@/views/data/dataDetail')
      }
    ]
  },
  {
    path: '/line',
    component: Layout,
    meta: {
      title: '线路申请',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_LINE
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/line/index'),
        meta: {
          title: '线路申请',
          isshow: false,
          roles: ROLES_LINE
        }
      }
    ]
  },
  {
    path: '/menu',
    component: Layout,
    meta: {
      title: '菜单权限',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'menuAuth',
        component: () => import('@/views/menu/index'),
        meta: {
          title: '菜单权限',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/official',
    component: Layout,
    meta: {
      title: '官网咨询',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'officialWebsiteConsulting',
        component: () => import('@/views/customerConsultation/index'),
        meta: {
          title: '官网咨询',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/taskSet',
    component: Layout,
    meta: {
      title: '配置任务',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'taskSet',
        component: () => import('@/views/taskSet/index.vue'),
        meta: {
          title: '配置任务',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/log',
    component: Layout,
    meta: {
      title: '调度日志',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'taskLog',
        component: () => import('@/views/log/index.vue'),
        meta: {
          title: '调度日志',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/industryTemplate',
    component: Layout,
    meta: {
      title: '行业模板',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: '/industryTemplateList',
        component: () => import('@/views/industryTemplate/index.vue'),
        meta: {
          title: '行业模板',
          isshow: false,
          roles: ROLES_ADMIN
        }
      },
      {
        path: '/createTemplate',
        name: 'addTemplate',
        component: () => import('@/views/industryTemplate/createTemplate')
      }
    ]
  },
  {
    path: '/dataEntry',
    component: Layout,
    meta: {
      title: '数据录入',
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'entryLog',
        component: () => import('@/views/dataEntry/index.vue'),
        meta: {
          title: '数据录入',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/dataUpdate',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: 'dataUpdate',
        component: () => import('@/views/dataUpdate/index.vue'),
        meta: {
          title: '数据更新',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/knowledgeBaseSystem',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        name: 'kbs',
        path: '/knowledgeBaseSystem',
        component: () => import('@/views/knowledgeBaseSystem/index.vue'),
        meta: {
          title: '智能搜索知识库',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/feedBack',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: '/feedBackCenter',
        component: () => import('@/views/feedBack/index.vue'),
        meta: {
          title: '智能搜索反馈',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  },
  {
    path: '/hotSet',
    component: Layout,
    meta: {
      icon: 'caidanquanxian',
      isshow: false,
      roles: ROLES_ADMIN
    },
    children: [
      {
        path: '/hotSetCenter',
        component: () => import('@/views/hotSet/index.vue'),
        meta: {
          title: '智能搜索热门配置',
          isshow: false,
          roles: ROLES_ADMIN
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/permissionRouter.js